import React from 'react';

const CATEGORIES = [
  { id: 'MODELS', label: 'Models', emoji: '✨' },
  { id: 'VOICEOVER', label: 'Voiceover', emoji: '🎤' },
  { id: 'DESIGN_BRANDING', label: 'Design', emoji: '🎨' },
  { id: 'MARKETING_SOCIAL', label: 'Marketing', emoji: '📱' },
  { id: 'VIDEO_PHOTOGRAPHY', label: 'Video & Photo', emoji: '🎬' },
  { id: 'WEB_DEVELOPMENT', label: 'Web & Dev', emoji: '💻' },
  { id: 'CONTENT_CREATION', label: 'Content', emoji: '✍️' },
  { id: 'STUDIO_RENTALS', label: 'Studios', emoji: '🎙️' },
  { id: 'EVENT_PLANNING', label: 'Events', emoji: '🎉' },
];

export function CategoryStrip({ selected, onSelect }) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
      <button
        onClick={() => onSelect(null)}
        className={`flex-shrink-0 flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all ${
          !selected
            ? 'bg-brand-gradient text-white'
            : 'bg-dark-surface border border-dark-border text-dark-subtext'
        }`}
      >
        All
      </button>
      {CATEGORIES.map(cat => (
        <button
          key={cat.id}
          onClick={() => onSelect(cat.id)}
          className={`flex-shrink-0 flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
            selected === cat.id
              ? 'bg-brand-gradient text-white'
              : 'bg-dark-surface border border-dark-border text-dark-subtext hover:border-brand-purple'
          }`}
        >
          <span>{cat.emoji}</span> {cat.label}
        </button>
      ))}
    </div>
  );
}

export { CATEGORIES };
export default CategoryStrip;
